module.exports = __webpack_public_path__ + "static/propref-00ef3a423736b160f9062b83db6e119d.mp4";